import { SnackBarTypes as types } from '../types'

export const setSnackbar = snackbar => ({
    type: types.SET_SNACKBAR,
    data: snackbar
})